export const PROFILE = 1;
export const INTERVIEW = 2;
export const JOB = 3;
export const FORMS = 4;
export const DOCUMENTS = 5;
export const EVALUATIONS = 6;
export const FORMATIONS = 7;
export const CANDIDATURE = 8;
export const CONVERSATIONS = 9;
export const INTERNAL_JOB = 10;